<template>

  <b-row>
    <b-col md="12">
      <b-card 
        no-body 
        :class="{ open: visibleBody }" 
      >
        <b-card-header 
          :class="{ collapsed: !visibleBody }" 
          data-toggle="collapse"
          @click="() => visibleBody = !visibleBody"
          style="background-color: #0080C9; color: white; font:45px; padding:15px; padding: 1rem"
        >
          <span class="lead collapse-title">
            <strong>PROCEDIMIENTOS CLÍNICOS</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body style="padding: 1px">

            <RegistrarEnvioProcesos
              :saveInState="saveProcesosInState"
              :esIess="esCoberturaIess"
              :tokenAtencion="tokenAtencion"
              :respaldo="dataRespaldo"
            />

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>

  </b-row>
  
</template>

<script>
import { mapState } from 'vuex';
import { RegistrarEnvioProcesos } from '@/views/procesoclinico/components';
import 'flatpickr/dist/flatpickr.css';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { loadRespaldo, saveRespaldo } from '../../helpers';


export default {
  
  components: {
    RegistrarEnvioProcesos
  },


  data() {
    return {
      idCita: null,
      tokenAtencion: null,
      identificadorAtencion: null,

      visibleBody: false,

      dataRespaldo:[]
    };
  },


  created() {
    this.loadData();
  },

  methods: {


    async loadData(){

      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;
      this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;

      if(this.idCita)
        this.dataRespaldo = loadRespaldo(this.idCita, 'procesos');
    },
  


    // lo voy a guardar en ls
    saveProcesosInState(procesosList) {
      if(this.identificadorAtencion)
        saveRespaldo(this.identificadorAtencion, 'procesos', procesosList);
    },
  },


  computed: {
    ...mapState({
      stDataCobertura: state => state.atencionCita?.dataCita?.cobSeleccionada.id,
    }),

    esCoberturaIess() {
      return this.stDataCobertura === '1';
    },
  },


}
</script>
